import React, {useMemo, useState} from 'react';
import FlipMove from "react-flip-move";
import SkillFormButton from "../../talent-application/components/SkillFormButton";
import UserDiscipline from "../../../models/UserDiscipline";
import {useProjectForm} from "../../../providers/ProjectFormProvider";
import ProjectSkillsForm from "./ProjectSkillsForm";
import EmptyBanner from "../../../components/EmptyBanner";
import {useSearchParams} from "react-router-dom";


// helper - ['one', 'two', 'three'] = "one, two, and three"
function makeListSentence(arr) {
    if (arr.length === 1) return arr[0];
    const firsts = arr.slice(0, arr.length - 1);
    const last = arr[arr.length - 1];
    return firsts.join(', ') + `${arr.length > 2 ? ',' : ''} and ` + last;
}

const FilteredSkills = ({available = [], canRemove = true,...props}) => {
    const {formModel: project} = useProjectForm();

    const selectedIds = useMemo(() => {
        return  TB.map(project.skills || [], 'id')
    }, [project?.skills]);

    const allSkills = useMemo(() => {
        let skills = TB.map(available || [], skill => {
            if (selectedIds.includes(parseInt(skill.id))) {
                return TB.find(project.skills, ['id', parseInt(skill.id)]);
            }

            return TB.pick(skill, ['id', 'name', 'type', 'type_name', 'is_extra']);
        })

        return TB.orderBy(skills || [], [
            'is_extra',
            skill => selectedIds.includes(skill?.id) ? selectedIds.indexOf(skill.id) : 1000,
            skill => selectedIds.includes(skill?.id),
        ], ['asc','asc', 'asc'])
    }, [
        selectedIds,
        available
    ]);

    return (
        <div className="flex flex-col items-stretch relative">
            {allSkills.length > 0 && (
                <div className="discipline-skills-container skill-importance-container relative">
                    <FlipMove typeName={null} maintainContainerHeight={true}>
                        {allSkills.map((skill, index) => {

                            return (
                                <SkillFormButton
                                    key={`selected-${index}-${skill.id}`}
                                    valuePropName={'importance'}
                                    disabled={props.isDisabled}
                                    scoringOptions={laravel.importance_levels}
                                    skill={skill}
                                    onlyEdit={!skill.is_extra}
                                    selected={selectedIds.includes(skill?.id)}
                                    onChange={(model) => {
                                        props.onChange(model)
                                    }}
                                />
                            )
                        })}
                    </FlipMove>
                </div>
            )}
        </div>
    )
}


const ProjectSkills = props => {
    const {formModel: project, isProjectUpdating: isDisabled, onFormChange} = useProjectForm()

    const [selectedDiscipline, setSelectedDiscipline] = useState(TB.first(project.disciplines));
    const [selectedDisciplines, setSelectedDisciplines] = useState([TB.first(project.disciplines)]);
    const [searchParams, setSearchParams] = useSearchParams();

    const selectedIds = useMemo(() => {
        return  TB.map(project.skills || [], 'id')
    }, [project?.skills]);

    const selectSkill = async (skill) => {
        let skills = [...(project.skills || [])];
        if (skill.importance !== undefined) {
            if (TB.find(skills, ['id', skill.id])) {
                skills = TB.map(skills, model => {
                    if (model.id === skill.id) {
                        return {...skill};
                    }
                    return model;
                });
            } else {
                skills.push(skill);
            }

        } else {
            skills = TB.xorBy(skills, [skill], 'id');
        }

        skills = TB.map(skills, skill => ({...skill, importance: parseInt(skill.importance)}))

        return props.onChange({skills})
    }

    // OLD CODE - SINGLE SELECTED DISCIPLINE
    // const selectedDisciplineSkills = useMemo(() => {
    //     let skills = UserDiscipline.skillsForDisciplines([selectedDiscipline?.id]);
    //     skills = TB.filter(skills, skill => !selectedIds.includes(skill.id))
    //     return TB.uniqBy(skills, 'id') || []
    // }, [selectedDiscipline, project.skills, isDisabled]);

    // const onSelectDiscipline = async (discipline) => {
    //     await toggleRoleSelect(false);
    //     await TB.wait(400);
    //     return  setSelectedDiscipline(discipline)
    // }

    // const toggleRoleSelect = (forceHide) => {
    //     let params = new URLSearchParams(searchParams);
    //     if (params.has('select-role') || forceHide) {
    //         params.delete('select-role');
    //     }else {
    //         params.set('select-role', '1');
    //     }
    //     return setSearchParams(params)
    // }
    //
    // const onSelectDiscipline2 = async (discipline) => {
    //     const _selectedDisciplines = TB.xorBy([...(selectedDisciplines || [])], [{...discipline}], 'id');
    //     // await TB.wait(400);
    //     return setSelectedDisciplines(_selectedDisciplines)
    // }

    const selectedDisciplineSkills2 = useMemo(() => {
        const disciplineIds = selectedDisciplines.map(d => d.id)
        let skills = UserDiscipline.skillsForDisciplines(disciplineIds);
        skills = TB.filter(skills, skill => !selectedIds.includes(skill.id))
        return TB.uniqBy(skills, 'id') || []
    }, [selectedDisciplines, project.skills, isDisabled]);


    return (
        <div className="flex flex-col gap-[32px]">
            <div className="flex flex-col justify-start items-start self-stretch relative gap-4">
                {/*<p className="self-stretch text-lg font-medium text-left text-black">*/}
                {/*    Skills Chosen*/}
                {/*</p>*/}

                {project.skills?.length > 0 && (
                    <FilteredSkills
                        available={project.skills}
                        onChange={skill => selectSkill(skill)}
                        isDisabled={isDisabled}/>
                )}
            </div>

            <div className="flex flex-col justify-start items-stretch self-stretch gap-6">
                <div className="flex flex-col justify-start items-start self-stretch relative gap-2">
                    {/*<p className="self-stretch text-lg font-medium text-left text-black">*/}
                    {/*    Add Additional Skills*/}
                    {/*</p>*/}

                    {/* OLD CODE - SINGLE SELECTED DISCIPLINE */}
                    {/* <div className="flex flex-row items-center justify-start gap-1">
                        <p className="text-sm">Most common skills for </p>
                        <p className="text-primary font-medium">{selectedDiscipline.name}</p>
                        <span onClick={() => toggleRoleSelect()}
                              className="clickable text-sm font-medium text-primary underline uppercase">
                            (see skills for other roles)
                        </span>
                    </div> */}

                    {/*<div className="flex gap-1">*/}
                    {/*    <p className="text-sm">Most common skills for <span className="text-primary font-medium">{makeListSentence(selectedDisciplines.map(d => d.name))}</span></p>*/}
                    {/*    <button type="button" onClick={() => toggleRoleSelect()} className="text-sm font-medium text-primary underline uppercase">(see skills for other roles)</button>*/}
                    {/*</div>*/}
                    <p className="text-sm">
                        Other common skills for this type of project that you can add:
                    </p>
                </div>

                <div className="flex flex-col justify-start items-stretch self-stretch relative gap-2">
                    {/* OLD CODE - SINGLE SELECTED DISCIPLINE */}
                    {/* {selectedDisciplineSkills.length > 0 ? (
                        <FilteredSkills
                            available={selectedDisciplineSkills}
                            onChange={skill => selectSkill({...skill, is_extra: true})}
                            isDisabled={isDisabled}/>
                    ) : (
                        <EmptyBanner message="All of the top skills for this role have been selected."/>
                    )} */}

                    {selectedDisciplineSkills2.length > 0 ? (
                        <FilteredSkills
                            available={selectedDisciplineSkills2}
                            onChange={skill => selectSkill({...skill, is_extra: true})}
                            isDisabled={isDisabled}/>
                    ) : (
                        <EmptyBanner message="All of the top skills for this role have been selected."/>
                    )}

                    <div className="skill-search-form bg-transparent max-w-[750px]">
                        <ProjectSkillsForm
                            project={project}
                            disabled={isDisabled}
                            onUpdate={skills => props.onChange({skills})}
                        />
                    </div>
                </div>

            </div>

            {/*<Modal isVisible={searchParams?.has('select-role')}*/}
            {/*       title="Choose a role below you want to see common skills for"*/}
            {/*       onCloseAction={() => toggleRoleSelect(false)}>*/}
            {/*    {selectedDiscipline && (*/}
            {/*        <ItemSelectModal*/}
            {/*            fieldName="disciplines"*/}
            {/*            selectText="Select Role"*/}
            {/*            // onSelectItem={onSelectDiscipline} // FOR SINGLE SELECT*/}
            {/*            multiSelect*/}
            {/*            selectedIds={selectedDisciplines.map(d => d.id)}*/}
            {/*            isDisabled={false}*/}
            {/*            categoryHeader="Role Category"*/}
            {/*            hideModal={() => toggleRoleSelect(false)}*/}
            {/*            itemHeader={`${laravel.platform_name} Role`}*/}
            {/*            items={disciplineCategories}*/}
            {/*            toggleItem={onSelectDiscipline2}*/}
            {/*        />*/}
            {/*    )}*/}
            {/*</Modal>*/}
        </div>
    );
};

ProjectSkills.propTypes = {};

export default ProjectSkills;